// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__2N_Dh","title":"card_title__2CuZJ","inActive":"card_inActive__3lhNE"};